export default {"src":"/_next/static/media/exclamation-triangle.c4a8ae5a.svg","height":518,"width":518,"blurWidth":0,"blurHeight":0};